export default "__VITE_ASSET__757267ea__"